import { generateContacts } from "../js-data/dummy/dummy-data";
import {
  deleteContact,
  dissociateContactFromContract,
  getContact,
  getContacts,
  storeContact,
  updateContact
} from "../api-helpers/api-contacts";
import { ContactTypes, InternalSubtypes } from "../constants/contact-enums";
import {
  contactInternalStaffSubTabs,
  contactPartnersVendorsSubTabs,
  contactsIndexTabs
} from "../js-data/contact-tab-groups";

export default {
  state: {
    isGettingContacts: false,
    contacts: null,
    isGettingContact: false,
    contact: null,
    isGettingCustomers: false,
    customers: null,
    isGettingPartnersAndVendors: false,
    partnersAndVendors: null,
    isGettingPartners: false,
    partners: null,
    isGettingVendors: false,
    vendors: null,
    isGettingInternalStaff: false,
    internalStaff: null,
    isGettingCrewLaborers: false,
    crewLaborers: null,
    isStoringContact: false,
    isUpdatingContact: false,
    isDeletingContact: false,
    isDissociatingContactFromContract: false,
    indexTabs: contactsIndexTabs,
    partnersAndVendorsSubTabs: contactPartnersVendorsSubTabs,
    internalStaffSubTabs: contactInternalStaffSubTabs
  },
  mutations: {
    setIsGettingContacts(state, bool) {
      state.isGettingContacts = bool;
    },
    setContacts(state, contacts) {
      state.contacts = contacts;
    },
    setIsGettingContact(state, bool) {
      state.isGettingContact = bool;
    },
    setContact(state, contact) {
      state.contact = contact;
    },
    setIsGettingCustomers(state, bool) {
      state.isGettingCustomers = bool;
    },
    setCustomers(state, customers) {
      state.customers = customers;
    },
    setIsGettingPartnersAndVendors(state, bool) {
      state.isGettingPartnersAndVendors = bool;
    },
    setPartnersAndVendors(state, partnersAndVendors) {
      state.partnersAndVendors = partnersAndVendors;
    },
    setIsGettingPartners(state, bool) {
      state.isGettingPartners = bool;
    },
    setPartners(state, partners) {
      state.partners = partners;
    },
    setIsGettingVendors(state, bool) {
      state.isGettingVendors = bool;
    },
    setVendors(state, vendors) {
      state.vendors = vendors;
    },
    setIsGettingInternalStaff(state, bool) {
      state.isGettingInternalStaff = bool;
    },
    setInternalStaff(state, internalStaff) {
      state.internalStaff = internalStaff;
    },
    setIsGettingCrewLaborers(state, bool) {
      state.isGettingCrewLaborers = bool;
    },
    setCrewLaborers(state, internalStaff) {
      state.crewLaborers = internalStaff;
    },
    setIsStoringContact(state, bool) {
      state.isStoringContact = bool;
    },
    setIsUpdatingContact(state, bool) {
      state.isUpdatingContact = bool;
    },
    setIsDeletingContact(state, bool) {
      state.isDeletingContact = bool;
    },
    setIsDissociatingContactFromContract(state, bool) {
      state.isDissociatingContactFromContract = bool;
    },
    setContactsIndexTabCounts(state, counts) {
      state.indexTabs = state.indexTabs.map(tab => {
        tab.count = counts[tab.slug];
        return tab;
      });
    },
    setPartnersAndVendorsSubTabCounts(state, counts) {
      state.partnersAndVendorsSubTabs = state.partnersAndVendorsSubTabs.map(
        tab => {
          tab.count = counts[tab.slug];
          return tab;
        }
      );
    },
    setInternalStaffSubTabCounts(state, counts) {
      state.internalStaffSubTabs = state.internalStaffSubTabs.map(tab => {
        tab.count = counts[tab.slug];
        return tab;
      });
    }
  },
  actions: {
    async getContacts({ state, commit, dispatch }) {
      let contactsAndCounts;

      if (!state.isGettingContacts) {
        commit("setIsGettingContacts", true);

        contactsAndCounts = await getContacts();

        commit("setContacts", contactsAndCounts.contacts);
        dispatch("updateCounts", contactsAndCounts);

        commit("setIsGettingContacts", false);
      }
      return contactsAndCounts;
    },
    async getContact({ state, commit }, contactId) {
      let contact;

      if (!state.isGettingContact) {
        commit("setIsGettingContact", true);

        contact = await getContact(contactId);

        commit("setContact", contact);

        commit("setIsGettingContact", false);
      }
      return contact;
    },
    async getCustomers({ state, commit, dispatch }) {
      let customersAndCounts;

      if (!state.isGettingCustomers) {
        commit("setIsGettingCustomers", true);

        customersAndCounts = await getContacts(ContactTypes.CUSTOMER);

        commit("setCustomers", customersAndCounts.contacts);
        dispatch("updateCounts", customersAndCounts);

        commit("setIsGettingCustomers", false);
      }
      return customersAndCounts;
    },
    async getPartners({ state, commit, dispatch }) {
      let partnersAndCounts;

      if (!state.isGettingPartners) {
        commit("setIsGettingPartners", true);

        partnersAndCounts = await getContacts(ContactTypes.PARTNER);

        commit("setPartners", partnersAndCounts.contacts);
        dispatch("updateCounts", partnersAndCounts);

        commit("setIsGettingPartners", false);
      }
      return partnersAndCounts;
    },
    async getVendors({ state, commit, dispatch }) {
      let vendorsAndCounts;

      if (!state.isGettingVendors) {
        commit("setIsGettingVendors", true);

        vendorsAndCounts = await getContacts(ContactTypes.VENDOR);

        commit("setVendors", vendorsAndCounts.contacts);
        dispatch("updateCounts", vendorsAndCounts);

        commit("setIsGettingVendors", false);
      }
      return vendorsAndCounts;
    },
    async getPartnersAndVendors({ state, commit, dispatch }) {
      let partnersVendorsAndCounts;

      if (!state.isGettingContacts) {
        commit("setIsGettingPartnersAndVendors", true);

        partnersVendorsAndCounts = await getContacts(
          ContactTypes.PARTNER_VENDOR
        );

        commit("setPartnersAndVendors", partnersVendorsAndCounts.contacts);
        dispatch("updateCounts", partnersVendorsAndCounts);

        commit("setIsGettingPartnersAndVendors", false);
      }
      return partnersVendorsAndCounts;
    },
    async getInternalStaff({ state, commit, dispatch }) {
      let internalStaffAndCounts;

      if (!state.isGettingInternalStaff) {
        commit("setIsGettingInternalStaff", true);

        internalStaffAndCounts = await getContacts(ContactTypes.INTERNAL);

        commit("setInternalStaff", internalStaffAndCounts.contacts);
        dispatch("updateCounts", internalStaffAndCounts);

        commit("setIsGettingInternalStaff", false);
      }
      return internalStaffAndCounts;
    },
    async getCrewLaborers({ state, commit, dispatch }) {
      let crewLaborers;

      if (!state.isGettingCrewLaborers) {
        commit("setIsGettingCrewLaborers", true);

        crewLaborers = await getContacts(
          undefined,
          InternalSubtypes.CREW_LABORER
        );

        commit("setCrewLaborers", crewLaborers.contacts);
        dispatch("updateCounts", crewLaborers);

        commit("setIsGettingCrewLaborers", false);
      }
      return crewLaborers;
    },
    async storeContact({ state, rootState, commit, dispatch }, contact) {
      let response;
      if (!state.isStoringContact) {
        commit("setIsStoringContact", true);

        response = await storeContact(contact);

        const entity = contact.isContractPartner ? "Partner" : "Contact";

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: `${entity} created successfully.`,
          errorText: `An error occurred while attempting to create ${entity}.`,
          afterSuccessFunction: () => {
            if (contact.isContractPartner) {
              dispatch("getContract", contact.contract_id);
            } else {
              if (rootState.Search.areSearchResultsShown) {
                dispatch("searchContacts", rootState.Search.searchTerm);
              } else {
                dispatch("getContacts");
              }
            }
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsStoringContact", false);
      }
      return response;
    },
    async updateContact({ state, rootState, commit, dispatch }, contact) {
      let response;
      if (!state.isUpdatingContact) {
        commit("setIsUpdatingContact", true);

        response = await updateContact(contact);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: contact.isContractPartner
            ? "Partner attached to Contract successfully."
            : "Contact updated successfully.",
          errorText: contact.isContractPartner
            ? "An error occurred while attempting to attach Partner to Contract"
            : "An error occurred while attempting to update Contact.",
          afterSuccessFunction: () => {
            if (contact.isContractPartner) {
              dispatch("getContract", contact.contract_id);
            } else if (contact.isShowView) {
              dispatch("getContact", contact.id);
            } else {
              if (rootState.Search.areSearchResultsShown) {
                dispatch("searchContacts", rootState.Search.searchTerm);
              } else {
                dispatch("getContacts");
              }
            }
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsUpdatingContact", false);
      }
      return response;
    },
    async deleteContact({ state, rootState, commit, dispatch }, contact) {
      let response;
      if (!state.isDeletingContact) {
        commit("setIsDeletingContact", true);

        response = await deleteContact(contact);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Contact deleted successfully.",
          errorText: "An error occurred while attempting to delete Contact.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchContacts", rootState.Search.searchTerm);
            } else {
              dispatch("getContacts");
            }

            commit("resetConfirmationModalParams");
          }
        });

        commit("setIsDeletingContact", false);
      }
      return response;
    },
    async dissociateContactFromContract({ state, commit, dispatch }, data) {
      let response;
      if (
        !state.isDissociatingContactFromContract &&
        data &&
        data.contactId &&
        data.contractId
      ) {
        commit("setIsDissociatingContactFromContract", true);

        response = await dissociateContactFromContract(
          data.contactId,
          data.contractId
        );

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Contact detached successfully.",
          errorText: "An error occurred while attempting to detach Contact.",
          afterSuccessFunction: () => {
            commit("resetConfirmationModalParams");
            dispatch("getContract", data.contractId);
          }
        });

        commit("setIsDissociatingContactFromContract", false);
      }
      return response;
    },
    updateCounts({ commit }, contactsAndCounts) {
      commit("setContactsIndexTabCounts", contactsAndCounts.type_counts);
      commit(
        "setPartnersAndVendorsSubTabCounts",
        contactsAndCounts.subtype_counts.partnerVendorSubtypes
      );
      commit(
        "setInternalStaffSubTabCounts",
        contactsAndCounts.subtype_counts.internalSubtypes
      );
    },
    async getFakeCustomers({ commit }) {
      commit("setIsGettingCustomers", true);

      let customers;
      if (
        window.localStorage.cusotmers &&
        JSON.parse(window.localStorage.customers).length
      ) {
        customers = JSON.parse(window.localStorage.customers);
      } else {
        customers = generateContacts(100, 100);
      }

      commit("setCustomers", customers);
      commit("setIsGettingCustomers", false);

      window.localStorage.customers = JSON.stringify(customers);

      return { customers };
    }
  }
};
